module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "OT",
    attrs: {
      "id": "for"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/contents#for"
    }
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('p', {
    staticClass: "Bodyflush"
  }, [_vm._v("Many students of the Bible treat the book of Proverbs as an afterthought in the Bible, an alien presence when compared to other books. After all, references to the great events of redemption (the patriarchs and matriarchs, exodus, conquest, and more) seem missing. Explicit references to covenant and law, prophets and priests are hard to find. While the prophets speak with a resounding “word of the Lord,” the sages who produced the book of Proverbs talk about their experiences, observations, and the traditions of those who came before them. Furthermore, when read in the light of similar writings from Egypt and elsewhere in the ancient Near East, the proverbs of the book show a remarkable similarity to those produced by their pagan counterparts.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("In a word, many scholars feel that the sages of Proverbs are a more kindred spirit to ideas outside the Bible than to the other voices within the Bible. As one author put it recently,")]), _vm._v(" "), _c('p', {
    staticClass: "EX"
  }, [_vm._v("Ancient Israel’s sages had no qualms incorporating the wisdom of other cultures. Biblical wisdom seeks the common good along with the common God. Wisdom’s international, indeed universal appeal constitutes its canonical uniqueness. The Bible’s wisdom corpus is the open door to an otherwise closed canon."), _c('sup', [_c('a', {
    attrs: {
      "href": "#/xhtml/#rfn1",
      "id": "fn1"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "Body1"
  }, [_vm._v("As a result of such thinking, the book of Proverbs, along with other wisdom books like Ecclesiastes and Job, are often treated as out of the mainstream theology of the Old Testament.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("That does not mean that Christian readers fail to appreciate Proverbs, however. Indeed, it is not uncommon to find people carrying a Bible that contains the New Testament with only the books of Psalms and Proverbs from "), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_vm._v("the Old Testament. After all, it is thought, Proverbs has the benefit of giving us some pretty concrete guidance for how to live life in a way that will lead to success and maybe even prosperity.")])]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_c('p', {
    staticClass: "Body"
  }, [_vm._v("Both of these perspectives, that Proverbs is an outlier within Old Testament theology and that Proverbs carries special weight on account of its concrete wisdom, demonstrate the need for people to better understand the book of Proverbs. While they capture an aspect of truth about the book, they are in the final analysis the result of a very superficial interpretation. For this reason, I am happy that Glenn Pemberton has brought his considerable insight to bear on the book of Proverbs. He combines his incisive theological sense along with a lively writing style to produce this wonderful book that will open up new depths of the book of Proverbs to his readers.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("I have been impressed with Dr. Pemberton’s thinking and writing for a long time. In particular, his previous studies of the Psalms, especially the laments and psalms of confidence, have opened up for me new dimensions of understanding. Dr. Pemberton is helpful because he allows his real life experience to inform his study, so he can explain to us not only about the meaning of the biblical text in its ancient context, but also how that ancient meaning impacts us today.")]), _vm._v(" "), _c('p', {
    staticClass: "Body"
  }, [_vm._v("I am excited and encouraged that you have chosen to read this book along with the book of Proverbs. As a result, your mind and heart will mature as you walk the path of life toward a deeper relationship with God.")]), _vm._v(" "), _c('p', {
    staticClass: "RightSb1"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REMPER")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONGMAN")]), _vm._v(" III"), _c('br'), _c('i', [_vm._v("Distinguished Scholar"), _c('br'), _vm._v("and Professor Emeritus"), _c('br'), _vm._v("Westmont College")])]), _vm._v(" "), _c('p', {
    staticClass: "line"
  }, [_c('img', {
    attrs: {
      "alt": "line",
      "src": "images/line1.jpg"
    }
  })])]), _c('p', {
    staticClass: "foot"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn1",
      "id": "rfn1"
    }
  }, [_vm._v("1")]), _vm._v(". W. P. Brown, "), _c('i', [_vm._v("Wisdom’s Wonder: Character, Creation, and Crisis in the Bible’s Wisdom Literature")]), _vm._v(" (Grand Rapids: Eerdmans, 2014), 3.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b4203ab8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/foreword.vue
// module id = 69
// module chunks = 0